import ConstantFunctions from "src/utils/constants_functions";

export type EventTimelineItem = {
  eventId: number | string;
  timestamp: string;
};

const EventTimeline = ({ events }: { events: EventTimelineItem[] }) => {
  const constFunctions = new ConstantFunctions();

  if (events.length === 0) {
    return (
      <div className="px-1 py-2 text-[10px] text-text-secondary">
        No event history available.
      </div>
    );
  }

  const latestEventIndex = events.length - 1;

  return (
    <div className="px-1 py-2">
      <div className="relative">
        {events.map((event, index) => {
          const isLatest = index === latestEventIndex;
          const isLast = index === events.length - 1;

          return (
            <div
              key={`${event.eventId}-${event.timestamp}`}
              className="relative flex gap-3 min-h-[56px]"
            >
              {!isLast && (
                <div className="absolute left-[7px] top-[16px] bottom-[-8px] w-[2px] bg-border-subtle" />
              )}
              <div className="relative z-[1] flex-shrink-0">
                <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full border-2 border-bg-status-green bg-bg-status-green">
                  <span
                    className={`material-symbols-outlined text-[10px] ${
                      isLatest ? "text-white" : "text-text-base"
                    }`}
                  >
                    check
                  </span>
                </div>
              </div>
              <div className="flex flex-col -mt-[2px] pb-4">
                <span className="text-[11px] font-semibold text-text-base">
                  Event {event.eventId}
                  {isLatest && (
                    <span className="ml-2 text-[9px] font-medium text-text-navbar-active">
                      CURRENT
                    </span>
                  )}
                </span>
                <span className="text-[10px] text-text-secondary mt-[2px]">
                  {constFunctions.formatDateTime(event.timestamp)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EventTimeline;
